/*
  nn-klaviyo-signup
  ------------------------------------------------------------
  メルマガ登録ボタンから Klaviyo のフォームを開く。

  data-nn-kl-form にフォームIDを持つ要素のクリックを、document 側で
  まとめて受ける（委譲）。ページ内に何個ボタンがあっても1本で足りる。

  インラインの onclick にしていない理由:
    - アプリが CSP を入れるとインラインハンドラは動かなくなる
    - 開かなかったときに原因を出せない

  押しても開かないときの段取り（Klaviyo 側の設定が分からなくても
  どれかが当たるように、方法を順に試す）:

    1. _klOnsite に openForm を積む（公式のやり方）
       ＋ klaviyo.openForm() があれば直接呼ぶ（新しめの klaviyo.js）
       ＋ _learnq にも積む（古い実装向け・無害）
    2. 以降は 0.25 秒ごとに「出たか」を見に行く（固定の待ち時間で
       判断しない。Klaviyo の表示は押してから10秒近くかかることがある）
    3. 2秒たっても出ていなければ、もう一度 1 を実行
       （klaviyo.js の読み込みが間に合わなかった場合）
    3.5 6秒たっても本命フォームがページに入ってすら来なければ、
       端末判定を外しているのでもう一方のID（PC用/スマホ用）を試す。
       同時には投げない（2枚重なって出るため）
    4. 10秒たっても出ていなければ、埋め込み用の入れ物
       <div class="klaviyo-form-{ID}"> をボタンの直後に差し込む。
       フォームが「埋め込み（Embedded）」形式で作られている場合は
       openForm では開かないため、これで出る。出たらボタンを隠す。
    5. 20秒たってもダメなら原因の手がかりを出す。
       console に必ず出し、URL に ?nn-debug=1 が付いていれば画面にも出す
       （スマホで確認するとき用）。
       data-nn-kl-fallback があればそのURLへ遷移する。
*/
(function () {
  if (window.nnKlaviyoSignupBound) return;
  window.nnKlaviyoSignupBound = true;

  var POLL = 250; // 出たかどうかを見に行く間隔
  var RETRY_AT = 2000; // 同じIDで押し直すまで
  var ALT_AT = 6000; // 端末判定を外していた場合に、もう一方のIDを試すまで
  var EMBED_AT = 10000; // 埋め込みを試すまで（★ ALT_AT より後であること。埋め込みの入れ物は .klaviyo-form-{ID} を名乗るため、先に入れると nodesFor が拾って代替IDの試行が止まる）
  var GIVEUP_AT = 20000; // 諦めて原因を出すまで（実測で11秒かかった例があるため長く取る）
  var DEBUG = window.location.search.indexOf('nn-debug') !== -1;

  function openForm(id) {
    window._klOnsite = window._klOnsite || [];
    window._klOnsite.push(['openForm', id]);
    try {
      if (window.klaviyo && typeof window.klaviyo.openForm === 'function') {
        window.klaviyo.openForm(id);
      }
    } catch (e) {
      /* キュー側に任せる */
    }
    try {
      if (window._learnq && typeof window._learnq.push === 'function') {
        window._learnq.push(['openForm', id]);
      }
    } catch (e) {
      /* 同上 */
    }
  }

  // 本当に画面に見えているか。
  // Klaviyo は閉じたポップアップを display:none ではなく祖先の opacity:0 で
  // 隠すため、大きさだけ見ると「閉じたのに開いている」と誤判定する
  // （実測: 閉じた後も 1000x751 のまま残る）。opacity まで見ること。
  function visible(node) {
    if (typeof node.checkVisibility === 'function') {
      if (!node.checkVisibility({ checkVisibilityCSS: true, checkOpacity: true })) return false;
    } else {
      // checkVisibility の無いブラウザ向け。祖先を辿って自前で見る
      for (var p = node; p && p.nodeType === 1; p = p.parentElement) {
        var cs = window.getComputedStyle(p);
        if (cs.display === 'none' || cs.visibility === 'hidden' || parseFloat(cs.opacity) === 0) {
          return false;
        }
      }
    }
    var r = node.getBoundingClientRect();
    return r.width > 0 && r.height > 0;
  }

  // そのIDのフォームがページに入っているか（表示は問わない）。
  // Klaviyo はその端末で出せるフォームだけを入れてくるので、
  // これが「この端末で使えるID」の判定になる。
  function nodesFor(id) {
    return document.querySelectorAll(
      '[data-testid="klaviyo-form-' + id + '"], .klaviyo-form-' + id
    );
  }

  // 「そのIDのフォーム」が実際に画面に出たか。
  // 判定は必ずID単位で行う。Klaviyo は自前の要素（kl-private-reset-css-*）を
  // 常時ページに置いており、それを数えると何も開いていなくても開いた事に
  // なってしまい、押し直し・埋め込み・原因表示が全部空振りする。
  function isOpen(ids) {
    for (var i = 0; i < ids.length; i++) {
      var nodes = nodesFor(ids[i]);
      for (var j = 0; j < nodes.length; j++) {
        if (visible(nodes[j])) return true;
      }
    }
    return false;
  }

  // この端末で使うフォームID を、使う順に並べて返す（先頭が本命）。
  //
  // PC用とスマホ用でフォームが別に作られていることがあり、Klaviyo は
  // 端末に合う方だけをページに入れてくる（実測: スマホ幅では PC用フォームが
  // DOM にすら現れず、openForm しても何も起きない）。
  // ページに入っている方があればそれを本命にし、無ければ画面幅で決める。
  //
  // ★ 同時に2つへ openForm を投げてはいけない。PC では PC用・スマホ用の
  //   どちらも開けてしまうため、ポップアップが2枚重なって出る（実際に踏んだ）。
  //   もう一方は「本命がそもそもページに入ってこなかった」時だけ後から試す。
  function idsFor(button) {
    var pc = (button.getAttribute('data-nn-kl-form') || '').trim();
    var sp = (button.getAttribute('data-nn-kl-form-mobile') || '').trim();
    var narrow = window.matchMedia && window.matchMedia('(max-width: 749px)').matches;

    var order = narrow ? [sp, pc] : [pc, sp];
    var all = [];
    for (var i = 0; i < order.length; i++) {
      if (order[i] && all.indexOf(order[i]) === -1) all.push(order[i]);
    }

    // すでにページに入っている方があれば、それを本命にする
    for (var k = 0; k < all.length; k++) {
      if (nodesFor(all[k]).length > 0) {
        var picked = all.slice();
        picked.splice(k, 1);
        picked.unshift(all[k]);
        return picked;
      }
    }
    return all;
  }

  // 埋め込み形式のフォーム用の入れ物。Klaviyo が中身を差し込む
  function embed(button, id) {
    var existing = document.querySelector('[data-nn-kl-embed="' + id + '"]');
    if (existing) return existing;
    var box = document.createElement('div');
    box.className = 'klaviyo-form-' + id;
    box.setAttribute('data-nn-kl-embed', id);
    box.style.marginTop = '12px';
    var parent = button.parentNode;
    if (parent) parent.insertBefore(box, button.nextSibling);
    return box;
  }

  function report(ids, box) {
    var lines = [
      'フォームID: ' + ids.join(' / '),
      'klaviyo.js: ' +
        (window.klaviyo
          ? '読み込み済み'
          : '未読込（Klaviyo アプリのアプリ埋め込みが無効か、読み込みに失敗しています）'),
      'キューの件数: ' + (window._klOnsite ? window._klOnsite.length : 'なし'),
      '埋め込み用の入れ物: ' + (box && box.children.length > 0 ? '中身が入った' : '空のまま'),
    ];
    console.warn(
      '[nn-klaviyo-signup] フォームが開きませんでした。\n  ' +
        lines.join('\n  ') +
        '\n  確認すること:' +
        '\n   ① このフォームIDが当ストアの Klaviyo アカウントのものか' +
        '（Klaviyo > Sign-up forms > 対象フォームを開き、URL 末尾の6文字）' +
        '\n   ② フォームが公開（Live）になっているか。下書きでは開きません' +
        '\n   ③ 表示先の絞り込み（対象ページ・デバイス）でこのページが外れていないか' +
        '\n   ④ すでに登録済み・一度閉じた履歴のある端末では表示されないことがあるため' +
        'シークレットウィンドウで試す'
    );
    if (!DEBUG) return;
    var panel = document.createElement('pre');
    panel.style.cssText =
      'margin:12px 0 0;padding:10px 12px;border:1px solid #e0b676;border-radius:4px;' +
      'background:#fffaf2;color:#7a4400;font-size:11px;line-height:1.7;white-space:pre-wrap;text-align:left;';
    panel.textContent = 'Klaviyo フォームが開きませんでした\n' + lines.join('\n');
    var parent = box && box.parentNode;
    if (parent) parent.appendChild(panel);
  }

  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!target || typeof target.closest !== 'function') return;
    var button = target.closest('[data-nn-kl-form]');
    if (!button) return;

    var ids = idsFor(button);
    if (ids.length === 0) return;

    event.preventDefault();

    // 自動表示などで既に出ているなら、二重に開かない
    if (isOpen(ids)) return;

    openForm(ids[0]);

    // 押している間に何度も走らせない
    if (button.getAttribute('data-nn-kl-pending') === '1') return;
    button.setAttribute('data-nn-kl-pending', '1');

    var fallback = button.getAttribute('data-nn-kl-fallback');
    var start = new Date().getTime();
    var retried = false;
    var alternated = false;
    var box = null;

    // 固定の待ち時間で判断せず、出るまで見に行く。
    // Klaviyo 側の表示は押してから10秒近くかかることがあり（実測 約7秒）、
    // 短い固定待ちだと開いたのに「開かなかった」と誤報を出してしまう。
    var timer = window.setInterval(function () {
      var elapsed = new Date().getTime() - start;

      if (isOpen(ids)) {
        // 出た。埋め込みを先に入れていたら後片付けする
        window.clearInterval(timer);
        button.removeAttribute('data-nn-kl-pending');
        if (box && box.children.length > 0) {
          button.style.display = 'none'; // 埋め込みが出たらボタンは不要
        } else if (box && box.parentNode) {
          box.parentNode.removeChild(box);
        }
        return;
      }

      if (!retried && elapsed >= RETRY_AT) {
        retried = true;
        openForm(ids[0]); // klaviyo.js の読み込み待ちだった場合の押し直し
      }

      // 本命がページに入ってすら来ないなら、端末判定を外している。
      // このときだけもう一方を試す（入っている場合は待つ。2枚出さないため）
      if (!alternated && ids[1] && elapsed >= ALT_AT && nodesFor(ids[0]).length === 0) {
        alternated = true;
        openForm(ids[1]);
      }

      if (!box && elapsed >= EMBED_AT) {
        box = embed(button, ids[0]); // 埋め込み形式だった場合
      }

      if (elapsed < GIVEUP_AT) return;

      window.clearInterval(timer);
      button.removeAttribute('data-nn-kl-pending');
      if (box && box.children.length > 0) {
        button.style.display = 'none';
        return;
      }
      report(ids, box);
      if (box && box.children.length === 0 && box.parentNode) box.parentNode.removeChild(box);
      if (fallback) window.location.href = fallback;
    }, POLL);
  });
})();
